import React from 'react';
import AssetsEn from '../components/AssetsEn';
import AssetsGalleryEn from '../components/AssetsGalleryEn';

function AssetsPageEn() {
  return (
    <div className="page">
      <AssetsEn />
      <AssetsGalleryEn />
    </div>
  );
}

export default AssetsPageEn;
